// removed by extract-text-webpack-plugin
module.exports = {"container":"_11l7wrz","container__column":"_11c8A0o","item":"_24mJMUE","label":"_38rHiUS","label__span1":"_1NS9p84","label__span2":"DMCNfEu","label__span3":"_1bP_JqJ","label__dark":"ciM41PK","label__light":"UFV0c0T"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/MarketingImage.css
// module id = ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/MarketingImage.css
// module chunks = client.sitechrome